import { LanguageService } from 'src/app/core/service/language.service';
import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber, CountryCode } from 'libphonenumber-js/min';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform
{
  constructor(private languageService: LanguageService) { }

  public transform(phoneValue: number | string): any
  {
    try
    {
      const countryCode = this.languageService.currentCountry;
      const regExp = /[0-9]{10}/;
      const phoneNumber = parsePhoneNumber(phoneValue + '', countryCode as CountryCode);
      if (regExp.test(phoneNumber.formatNational()))
      {
        return phoneValue;
      }
      else
      {
        return phoneNumber.formatNational();
      }
    } catch
    {
      return phoneValue;
    }
  }

}
